module.exports = __webpack_public_path__ + "img/404.789887e9.png";